import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import ModuleTermsAcceptanceGate from "../components/terms/ModuleTermsAcceptanceGate";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/styles/common-header-footer.scss";

/** Pages under PublicLayout that render HubHomeFooter (or similar) must not stack the legacy orange footer. */
function usesOwnSiteFooter(pathname) {
  return pathname === "/logistics/rfq" || pathname.startsWith("/logistics/rfq/");
}

export default function PublicLayout() {
  const { pathname } = useLocation();
  const showLegacyFooter = !usesOwnSiteFooter(pathname);

  return (
    <div className="d-flex flex-column min-vh-100">
      <ModuleTermsAcceptanceGate>
        <Outlet />
      </ModuleTermsAcceptanceGate>
      {showLegacyFooter ? <Footer /> : null}
    </div>
  );
}

